/**
 * Ported 1:1 from Client/Assets/NetworkModels/MessageTag.cs (enum MessageTag : ushort).
 *
 * THE ORDER / NUMERIC VALUES ARE LOAD-BEARING — they are the wire opcodes. The C# enum is
 * append-only ("should add to the bottom of the list"); keep this in lock-step. The codec.test.ts
 * golden test pins a few values and the total count so reordering breaks CI.
 *
 * TODO(plan §2): replace this hand-port with a generator that emits this file from MessageTag.cs.
 */
export enum MessageTag {
  SendMessage = 0,
  LoadLogin = 1,
  Login = 2,
  PinPad = 3,
  Register = 4,
  ForgotPassword = 5,
  Telegram = 6,
  ReadMessage = 7,
  OnlineList = 8,
  Ticket = 9,
  ChangePin = 10,
  ExitView = 11,
  HistoryRound = 12,
  Winners = 13,
  TopHands = 14,
  SaveAvatar = 15,
  GetProfile = 16,
  ChangePassword = 17,
  SaveBankInformation = 18,
  Online = 19,
  Disconnect = 20,
  IsReady = 21,
  WaitReady = 22,
  Update = 23,
  MainMenu = 24,
  ChangeRoom = 25,
  Status = 26,
  CheckParent = 27,
  GetGame = 28,
  Move = 29,
  SelectCard = 30,
  Cash = 31,
  CashWait = 32,
  AgentRequest = 33,
  CancelPayback = 34,
  RequestPayback = 35,
  Pay = 36,
  RecheckPayments = 37,
  TransactionList = 38,
  AgentList = 39,
  SearchGame = 40,
  SearchGameExit = 41,
  JoinGame = 42,
  WatchGame = 43,
  Ready = 44,
  NotReady = 45,
  ObsoleteNotReady = 46,
  ResignGame = 47,
  NewGame = 48,
  RollDice = 49,
  Chat = 50,
  TicketSave = 51,
  Refresh = 52,
  InGameMessage = 53,
  StartGamePanel = 54,
  CanselGame = 55,
  RoundInfo = 56,
  SelectHokm = 57,
  GameInfo = 58,
  GameAlive = 59,
  Undo = 60,
  SelectHakem = 61,
  BackLink = 62,
  SaveProfile = 63,
  Logout = 64,
  GamePreview = 65,
  Hit = 66,
  Stand = 67,
  GetNewGameConfigs = 68,
  Bet = 69,
  SwitchTurn = 70,
  ShowRoundResult = 71,
  ShowNextDealer = 72,
  ReadyToPlay = 73,
  ShowEndGameResult = 74,
  OnlineListUpdate = 75,
  Reconnect = 76,
  StressTest = 77,
}

/** Total number of defined tags — pinned by the golden test to catch accidental additions/removals. */
export const MESSAGE_TAG_COUNT = 78;
